// This file was automatically generated from appchart.letters.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.letters');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.appchart.letters.selectAttachments');
goog.require('el8.template.appchart.letters.unreadAlertNotification');
goog.require('el8.template.appshared.docTags');
goog.require('el8.template.ptdata.patients');
goog.require('el8.template.uiwidget.Icd10ListEditor');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="third-pane-header thirdPaneHeaderContainer">', (opt_data.isReferralLetter) ? '<p class="padl10">Referral</p>' : '', '<span id="thirdpane-view-mode-trigger" class="threePaneButton"></span></div><div class="el8MailBackground"><div class="third-pane-content el8OverflowAuto padh10">');
  if (opt_data.isReferralLetter) {
    el8.template.appchart.letters.referralLetterForm(opt_data, output);
  } else {
    el8.template.appchart.letters.letterForm(opt_data, output);
  }
  output.append('</div></div>');
  el8.template.appchart.letters.optionsPane(opt_data, output);
  output.append('<div class="button-section"><div id="letter-buttons" class="ui-dialog-buttonpane"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.unreadLetterNotification = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FieldSection mt10"><label class="el8label el8FieldMail">Unread Alert</label><div class="el8MailFieldPadding padt2"><span class="el8StandardFontSize">Notify me if not opened</span><select class="auto-save w28 unread-alert-in-days-selection ml10" name="unreadAlertInDays">');
  el8.template.appchart.letters.unreadAlertNotification.notificationSelection({showDisabledChoice: true, showSpecificDate: true}, output);
  output.append('</select><span class="unread-notification-date-label el8NotificationDateLabel"></span><div class="el8EditorTextareaWrap datePickerWrap unread-alert-date-picker ml10 el8InlineBlock"><input type="text" class="auto-save datePicker" name="unreadAlertDate" /></div><p><a class="el8StandardLink" target="_blank" rel="noopener" href="/settings/patientpassport/">edit default notification settings</a></p></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.behalfPhysiciansSelectionOptions = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var pList3169 = opt_data.behalfPhysicians;
  var pListLen3169 = pList3169.length;
  if (pListLen3169 > 0) {
    for (var pIndex3169 = 0; pIndex3169 < pListLen3169; pIndex3169++) {
      var pData3169 = pList3169[pIndex3169];
      output.append('<option value="', soy.$$escapeHtml(pData3169.staffId), '">', soy.$$escapeHtml(pData3169.name), '</option>');
    }
  } else {
    output.append('<option value="">--</option>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.referralLetterForm = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<form id="letter-form" class="el8MailBackground padb50">');
  el8.template.appchart.letters.toSection(opt_data, output);
  el8.template.appchart.letters.consultantPatientDetails(opt_data.patient, output);
  output.append('<div class="el8FieldSection mt10"><label class="el8label el8FieldMail">Reason</label><div class="el8MailFieldPadding el8TextareaWrap"><textarea type="text" class="w100" name="body"></textarea></div></div><div class="el8FieldSection mt10"><ul class="letter-template-section el8ButtonContainer el8LettersTemplates" style="display: none"><li class="el8ButtonItem"><a tabindex="-1" class="template-save-trigger el8FormLink">Save as Template</a></li><li class=""><a tabindex="-1" class="template-menu-trigger el8FormLink">Templates <span class="el8DownArrowIcon"></span></a></li></ul></div>');
  if (opt_data.showBehalfPhysicians) {
    output.append('<div class="el8FieldSection mt10"><label class="el8label el8FieldMail">On Behalf Of</label><div class="el8MailFieldPadding"><select class="w100 behalf-physicians" name="onBehalfOf">');
    el8.template.appchart.letters.behalfPhysiciansSelectionOptions({behalfPhysicians: opt_data.behalfPhysicians}, output);
    output.append('</select></div></div>');
  }
  output.append('<div class="el8FieldSection mt10"><label class="el8label el8FieldMail">Auth. For</label><div class="el8MailFieldPadding"><select class="auto-save w100" name="authorizationFor">');
  var aList3190 = opt_data.referralAuths;
  var aListLen3190 = aList3190.length;
  for (var aIndex3190 = 0; aIndex3190 < aListLen3190; aIndex3190++) {
    var aData3190 = aList3190[aIndex3190];
    output.append('<option value="', soy.$$escapeHtml(aData3190[0]), '">', soy.$$escapeHtml(aData3190[1]), '</option>');
  }
  output.append('</select></div></div><div class="el8FieldSection mt10"><label class="el8label el8FieldMail">Auth. #</label><div class="el8MailFieldPadding el8TextareaWrap"><input type="text" class="auto-save w100" name="authNumber" /></div></div><div class="el8FieldSection mt10"><label class="el8label el8FieldMail">Dxs</label>');
  el8.template.uiwidget.Icd10ListEditor.referralBillDxEntryField(opt_data, output);
  output.append('</div><div class="el8FieldSection mt10">');
  el8.template.appchart.letters.postDateSection(null, output);
  output.append('</div>');
  el8.template.appchart.letters.unreadLetterNotification(null, output);
  output.append('<div class="el8FieldSection mt10 print-headers-section" style="display: none"></div>');
  el8.template.appchart.letters.attachmentsAndPassportNotifications({isSendToPatient: false}, output);
  output.append('</form>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.attachmentsAndPassportNotifications = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8LettersAttachmentsHeader mt20"><label class="el8label el8FieldMailAttach">Attachments:<span class="el8LetterPageCountTotal total-page-count"></span></label><div class="attachments-loading-holder"></div></div><div class="attachments-list"></div>', (opt_data.isSendToPatient) ? '<div class="el8FieldSection pt-attachment-notice"></div>' : '', '<div class="pad5 mt5"><button type="button" tabindex="-1" class="el8button cancel attach-items el8FormLink">Select Chart Items to Attach</button><span class="el8AppText padl2">|</span><button type="button" tabindex="-1" class="el8button cancel export-chart el8FormLink">Attach Everything in Chart</button><span class="el8AppText padl2">|</span>');
  if (el8Globals.FEATURES.DocTagsForLetters) {
    el8.template.appshared.docTags.docTagsSection(null, output);
  }
  output.append('</div>');
  if (! opt_data.isSendToPatient) {
    output.append('<div class="el8FieldSection prov-email-notification" style="display: none">');
    el8.template.appchart.letters.provEmailNotification(null, output);
    output.append('</div><div class="el8FieldSection prov-passport-notification" style="display: none">');
    el8.template.appchart.letters.provPassportNotification(null, output);
    output.append('</div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.postDateSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<label class="el8label el8FieldMail">Post Date</label><div class="el8MailFieldPadding el8TextareaWrap datePickerWrap"><input type="text" class="auto-save datePicker" name="deliveryDate" /></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.letterForm = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<form id="letter-form" class="el8MailBackground', (! opt_data.isSendToPatient) ? ' padb50' : '', '">');
  el8.template.appchart.letters.toSection(opt_data, output);
  if (! opt_data.isSendToPatient) {
    el8.template.appchart.letters.consultantPatientDetails(opt_data.patient, output);
  }
  output.append('<div class="el8FieldSection mt10"><label class="el8label el8FieldMail">Subject</label><div class="el8MailFieldPadding el8TextareaWrap"><textarea type="text" class="w100" name="subject"></textarea></div></div><div id="directMessageSubjectDisclaimer" class="hidden"><div class="el8MailFieldPadding el8ProfileUpdateText">Note: For direct messages, do not include sensitive or private patient information in subject line.</div></div><div class="el8LettersSpacer"><div class="el8TextareaWrap"><textarea type="text" class="w100" name="body"></textarea></div></div><div class="el8FieldSection mt10"><ul class="letter-template-section el8ButtonContainer el8LettersTemplates fr" style="display: none"><li class="el8ButtonItem"><a tabindex="-1" class="template-save-trigger el8FormLink">Save as Template</a></li><li class=""><a tabindex="-1" class="template-menu-trigger el8FormLink">Templates <span class="el8DownArrowIcon"></span></a></li></ul>');
  el8.template.appchart.letters.postDateSection(null, output);
  output.append('</div>');
  el8.template.appchart.letters.unreadLetterNotification(null, output);
  output.append('<div class="el8FieldSection mt10 print-headers-section" style="display: none"></div>');
  el8.template.appchart.letters.attachmentsAndPassportNotifications({isSendToPatient: opt_data.isSendToPatient}, output);
  output.append((opt_data.isSendToPatient && el8Globals.FEATURES.MUReports) ? '<div class="cardColumnTB mt30 padh5"><p class="mu-info-header el8Bold el8AppColor padt10 padb5"><span class="mu-info-status" class="el8Elt"></span>For MIPS Compliance:</p><div class="mu-info-body el8FieldSectionOverflow padb30"><ul class="el8ButtonContainer fr"><li class="el8ButtonItem mr20"><label class="el8label el8Radio"><input class="mtneg4" type="radio" name="isPatientReminder" value="1"><span class="el8LeftIndent">Yes</span></label></li><li class="el8ButtonItem mr20"><label class="el8label el8Radio"><input class="mtneg4" type="radio" name="isPatientReminder" value="0" checked><span class="el8LeftIndent">No</span></label></li></ul><p class="el8AppColor padt2 w75">MIPS: Patient Reminder?</p></div></div>' : '', '</form>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.toSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FieldSection mt10"><label class="el8label el8FieldMail">To</label>');
  if (opt_data.isSendToPatient) {
    output.append('<div class="el8MailFieldPadding el8FieldSection patient-to-field"><div class="');
    el8.template.ptdata.patients.genderIconSmall(opt_data.patient, output);
    output.append('"></div><p class="el8PatientRecipient">');
    el8.template.ptdata.patients.patientFacingName(opt_data.patient, output);
    output.append('</p></div>');
  } else {
    output.append('<div class="el8MailFieldPadding el8TextareaWrap to-field-input mr50"></div>');
  }
  output.append('</div>', (el8Globals.FEATURES.ProvidersNetwork && ! opt_data.isSendToPatient) ? '<div class="el8FieldSection add-to-main-providers-section" style="display:none;"><div class="ml75"><label class="el8label el8CheckMark"><input name="addToMainProviders" type="checkbox" class="options" /><span class="label-text">Add to Provider List</span></label></div></div>' : '');
  if (el8Globals.FEATURES.PLR4Everyone && ! opt_data.isSendToPatient) {
    output.append('<div class="el8FieldSection add-to-care-team-section" style="display:none;"><div class="ml75"><label class="el8label el8CheckMark"><input name="addToCareTeam" type="checkbox" class="options" /><span class="add-to-care-team-label label-text el8BrandDark">Grant access to ', soy.$$escapeHtml(opt_data.patient.firstName), ' ', soy.$$escapeHtml(opt_data.patient.lastName), '\'s shared records</span></label></div></div><div class="mt5 sharing-not-enabled-prompt" style="display: none;">');
    el8.template.appchart.letters.plrSharingNotEnabledPrompt(null, output);
    output.append('</div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.plrSharingNotEnabledPrompt = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div style="border: 1px solid #ccc; background-color: #e5ebee; padding: 5px 80px 5px 80px; font-size: 1.3em;" >Currently you\'re not sharing your records. <a class="start-sharing-letter-form-trigger"><span>Start sharing</span></a> with other providers caring for this patient.</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.headersList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.headers.length) {
    output.append('<label class="el8label el8FieldMail">Print Header</label><div class="el8MailFieldPadding padt2"><select name="printHeaderId" class="w30">');
    var headerList3277 = opt_data.headers;
    var headerListLen3277 = headerList3277.length;
    for (var headerIndex3277 = 0; headerIndex3277 < headerListLen3277; headerIndex3277++) {
      var headerData3277 = headerList3277[headerIndex3277];
      output.append('<option value="', soy.$$escapeHtml(headerData3277.id), '" ', (opt_data.selectedHeaderId == headerData3277.id) ? 'selected' : '', '>', soy.$$escapeHtml(headerData3277.name), '</option>');
    }
    output.append('</select></div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.optionsPane = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="ui-dialog-optionspane el8LetterCheckboxWrap"><p class="options-pane-header"></p>', (opt_data.isSendToPatient) ? '<div class="h20 padt2"><label class="el8label el8CheckMarkSmall mr10"><input type="checkbox" name="closeThread" ' + ((el8Globals.FEATURES.NoPatientResponses) ? 'checked="true"' : '') + ' /><span class="el8NormalText el8StandardFontSize">Do not allow patient to respond to this letter</span></label></div>' : (! el8Globals.PASSPORT_EMR) ? '<div class="fax-attachments-section h20 padt2"><label class="el8label el8CheckMarkSmall"><input type="checkbox" name="includeAttachments" class="include-attachments-check"/><span class="el8NormalText el8StandardFontSize">Also fax copies of the attachments</span></label><span class="el8NormalText padl5 el8StandardFontSize"><a target="_blank" rel="noopener" href="https://help.elationhealth.com/s/article/sending-letters-and-referrals">Learn more</a></span></div>' : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.attachmentList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.appchart.letters.selectAttachments.attachmentList(soy.$$augmentData(opt_data, {renderEmptyText: false, renderPageCount: true}), output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.provPassportNotification = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8Spacer"></div><div class="pad10 el8GrayText"><p><i>Note: This recipient is an Elation user and will have access to an electronic copy of this letter and its attachments, independent of the "Sent by" delivery method selected above.</i></p></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.provEmailNotification = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8Spacer"></div><div class="mr5 el8NotificationCaution"><p>The recipient will be instructed to call your practice for a Provider Security Code for a one-time Provider Passport registration to access your letter.</p></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.faxLimitWarning = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('You are about to fax ', soy.$$escapeHtml(opt_data.totalPageCount), ' pages. ', (opt_data.totalPageCount > opt_data.metrofaxLimit) ? 'Letters larger than ' + soy.$$escapeHtml(opt_data.metrofaxLimit) + ' pages may experience difficulty when being faxed. Please limit your fax to ' + soy.$$escapeHtml(opt_data.metrofaxLimit) + ' pages to ensure proper receipt of this fax or send this through email.' : 'Would you like to send the letter with its attachments as a PDF securely via email?', '\n\nTo send via email, click on the "Go Back" button below and choose the Send by "Email" option at the top of the letter. You will be notified when the recipient has received the PDF.');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.patientAttachmentNotice = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="el8AttachmentNoticeText">Note: The patient currently has access to ');
  switch (opt_data.grantLevel) {
    case 0:
      output.append('the Clinical Profile');
      break;
    case 1:
      output.append('Objective Data and the Problem List from the Clinical Profile');
      break;
    case 2:
      output.append('Objective Data from the Clinical Profile');
      break;
    case 3:
      output.append('Clinical Profile, Expanded Summary,');
      break;
  }
  output.append(' and Demographics through Passport. <a class="invite-passport-trigger">edit sharing settings</a></p>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.consultantPatientDetails = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FieldSection mt10 patient-details-wrapper"><label class="el8label el8FieldMail">Patient</label><div class="el8MailFieldPadding el8Wrap"><p>');
  el8.template.ptdata.patients.displayName(opt_data, output);
  output.append(', D.O.B.: ', (soy.$$escapeHtml(opt_data.dob)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.dob)) : ''), '</p></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.deliveryMethodList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.letter.isSendToPatient) ? (opt_data.ptInviteStatus == 'NOT_INVITED') ? 'After you click "Sign &amp; Send", you will be prompted to invite the patient to Passport.' : 'This ' + ((opt_data.letter.isReferralLetter) ? 'referral' : 'letter') + ' will be sent to the patient via Passport.' : (opt_data.letter.deliveryMethod == 'passport') ? (opt_data.recipient.access_practice_fax || opt_data.recipient.fax) ? 'A copy of this ' + ((opt_data.letter.isReferralLetter) ? 'referral' : 'letter') + ' will be faxed with a link to view an interactive chart containing the attachments online.' + ((opt_data.recipient.email) ? ' E-mail notification will also be sent.' : '') : 'An e-mail will be sent with a link to view the ' + ((opt_data.letter.isReferralLetter) ? 'referral' : 'letter') + ' and attachments in an interactive chart.' : (opt_data.letter.deliveryMethod == 'emr') ? 'This ' + ((opt_data.letter.isReferralLetter) ? 'referral' : 'letter') + ' will be sent to the recipient\'s Elation Health account.' : (opt_data.letter.deliveryMethod == 'fax') ? (opt_data.letter.sendToContactId) ? 'A copy of this ' + ((opt_data.letter.isReferralLetter) ? 'referral' : 'letter') + ' will be faxed with a link to view an interactive chart containing the attachments online.' + ((opt_data.recipient.email) ? ' E-mail notification will also be sent.' : '') + ((opt_data.recipient.direct_message) ? ' Direct message will also be sent.' : '') + ((opt_data.pageCount > opt_data.FAX_PAGE_LIMIT) ? '<span class="el8LetterCautionText">Attachments will not be included in the fax because they exceed ' + soy.$$escapeHtml(opt_data.FAX_PAGE_LIMIT) + ' pages. To fax this ' + ((opt_data.letter.isReferralLetter) ? 'referral' : 'letter') + ' and its attachments, click "Sign &amp; Download PDF," print the PDF, and use your fax machine.</span>' : '') : (opt_data.pageCount <= opt_data.FAX_PAGE_LIMIT) ? ((opt_data.letter.isReferralLetter) ? 'Referral' : 'Letter') + ' and its attachments will be faxed.' : ((opt_data.letter.isReferralLetter) ? 'Referral' : 'Letter') + ' and its attachments cannot be faxed as it exceeds ' + soy.$$escapeHtml(opt_data.FAX_PAGE_LIMIT) + ' pages.<span class="el8LetterCautionText">To fax, click the "Sign &amp; Print" button and use your fax machine.</span>' : (opt_data.letter.deliveryMethod == 'email') ? 'An e-mail notification will be sent to view ' + ((opt_data.letter.isReferralLetter) ? 'referral' : 'letter') + ' and attachments online.' : (opt_data.letter.deliveryMethod == 'direct') ? 'This ' + ((opt_data.letter.isReferralLetter) ? 'referral' : 'letter') + ' and attachments will be sent via direct message into the recipient\'s EMR account.' + ((opt_data.recipient.fax) ? ' A fax for this ' + ((opt_data.letter.isReferralLetter) ? 'referral' : 'letter') + ' will also be sent.' : '') : 'Add a fax number or e-mail address to Contact\'s details to send ' + ((opt_data.letter.isReferralLetter) ? 'referral' : 'letter') + '.');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.defaultFaxBody = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('\n\nTo help you with seeing this patient, I\'ve created a customized, interactive, HIPAA compliant patient chart that you can easily access online by following the instructions below.  Please use Google Chrome or Firefox instead of Internet Explorer if at all possible to view the interactive chart.');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.defaultDirectMessageBody = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('\n\nTo help you with seeing this patient, I am sending this to you via fax as well as via direct message, where you can access this patient information directly in your EMR account. Please find the message and attachments here.');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.defaultCareTeamInviteToShareBody = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('\nI\'d like to invite you to start sharing your records for this patient with our Care Team. Doing so provides us with automatic update to this patient\'s chart, and as a member of the Care Team, you see information that other members of the Care Team make available in real time.\n\nYou can easily start sharing by clicking on Care Team icon in the top navigation bar.  Then select the gear icon next to your name and click Share record with Care Team.');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.defaultAddToCareTeamBody = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('\nI’ve given you access to this patient\'s shared record. This will automatically update you with real-time clinical data from other providers on Elation who are caring for this patient — helping you stay up-to-date on their most recent care information.\n\nMake sure that you\'re sharing your records too to automatically alert other members of the Care Team of any updates. You can do this by clicking on Care Team icon in the top navigation bar. Then select the gear icon next to your name and click "Share my records".');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.defaultAddToCareTeamBodyFax = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('\nTo help you with seeing this patient, I\'ve added you to their Care Team on Elation Health. This creates a customized, interactive, HIPAA-compliant patient chart that you can easily access online by following the instructions below. Please use Google Chrome or Firefox instead of Internet Explorer if at all possible to view the interactive chart.');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.rawFaxNagDipdown = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.ftue) ? '<p class="el8FTUEStepCountRawFax">Step 2 of 3</p>' : '', '<p class="el8InfoTipHeader padb5">Save this number so you don\'t have to enter it again.</p><form class="dipdown-form el8RawFaxNagForm"><div class="el8FieldSection"><label class="el8label el8RawFaxNagLabel">This number belongs to:</label><div class="el8RawFaxNagRadioWrap"><input name="contactType" type="radio" class="options" value="physician" checked /><span class="el8StandardFontSize el8FFF">Individual</span><input name="contactType" type="radio" class="options" value="medical_group" /><span class="el8StandardFontSize el8FFF">Organization</span></div></div><div class="physician-block clearfix"><div class="el8ProfileLeftInput el8RawFaxNag el8TextareaWrap mr10"><input type="text" class="w100" name="firstName" /></div><div class="el8ProfileLeftInput el8RawFaxNag el8TextareaWrap"><input type="text" class="w100" name="lastName" /></div></div><div class="medical-group-block hidden"><div class="el8FieldSection"><div class="clearM el8TextareaWrap"><input type="text" class="w100" name="name" /></div></div></div><div class="button-section el8RawFaxNagButtons"></div></form>');
  if (!opt_sb) return output.toString();
};
